"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const input_1 = tslib_1.__importDefault(require("antd/es/input"));
exports.Input = React.forwardRef((_a, ref) => {
    var { className = '' } = _a, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(input_1.default, Object.assign({}, props, { className: `clp-input ${className}`, ref: ref })));
});
//# sourceMappingURL=Input.js.map